export const addAndRemovePermissions = {
  addAndRemovePermissions(newValue,oldValue){
    if(newValue != null && oldValue == null){      
      this.addPermissionsID(newValue)
    }else if(newValue != null && oldValue != null){      
       this.deletePermissionsID(oldValue)
       this.addPermissionsID(newValue)
      
    }else{
       this.deletePermissionsID(oldValue)   
    }
}
}
